<template>
    <div class="col-12 row p-4 px-2 m-0 justify-content-around">
        <div class="col-12 card card-outline card-primary p-2">
            <div class="card-header">
                <h3 class="h3">{{ t("new-general.admin.mail") }}</h3>
            </div>
            <div class="card-body table-responsive" id="my-table">
                <div>
                    <div class="form-group">
                        <label for="subject">Assunto do email</label>
                        <input
                            type="text"
                            class="form-control"
                            name="subject"
                            id="subject"
                            v-model="email.subject"
                        />
                    </div>
                    <ckeditor
                        v-model="email.message"
                        :editor="editor"
                        :config="editorConfig"
                    />
                    <div class="row m-0 p-o">
                        <div class="form-group col-6" style="gap: 10px">
                            <label for="file">Anexar ficheiro</label>
                            <input
                                type="file"
                                class="form-control"
                                name="file"
                                id="file"
                                @change="changeAttach"
                            />
                        </div>
                        <div class="form-group col-6" style="gap: 10px">
                            <label class="col-12"
                                >Enviar aos usuário selecionados</label
                            >
                            <button
                                class="btn btn-success btn-flat"
                                @click="sendMail"
                            >
                                Enviar email
                            </button>
                        </div>
                    </div>
                </div>

                <hr />
                <div class="row m-0">
                    <div class="p-2 col-12 col-md-7 col-lg-8">
                        <label for="q">Pesquisa r&aacute;pida</label>
                        <input
                            type="search"
                            placeholder="Procurar nome ou email"
                            id="q"
                            name="q"
                            v-model="q"
                            class="form-control"
                        />
                    </div>
                    <div class="p-2 col-12 col-md-5 col-lg-4">
                        <label for="q">Subcri&ccedil;&atilde;o</label>
                        <VDateInput
                            v-model="orders.dates"
                            clearable
                            label="De - até"
                            variant="outlined"
                            multiple="range"
                        />
                    </div>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="table-primary">
                                <label role="button" @click="orderBy('id')"
                                    >#</label
                                >
                            </th>
                            <th class="table-primary">
                                <div class="icheck-primary">
                                    <input
                                        type="checkbox"
                                        name="checkall"
                                        id="checkall"
                                        @change="selectAll"
                                    />
                                    <label for="checkall"></label>
                                </div>
                            </th>
                            <th class="table-primary">
                                <label role="button" @click="orderBy('email')"
                                    >Email</label
                                >
                            </th>
                            <th class="table-primary">
                                <label role="button" @click="orderBy('name')"
                                    >Nome</label
                                >
                            </th>
                            <th class="table-primary">
                                <label role="button" @click="orderBy('level')"
                                    >Cargo</label
                                >
                            </th>
                            <th class="table-primary">
                                <label>Telefone</label>
                            </th>
                            <th class="table-primary">
                                <label
                                    role="button"
                                    @click="orderBy('subscription_active')"
                                    >Estado</label
                                >
                                <select
                                    v-model="orders['status']"
                                    style="
                                        border: 1px solid gray;
                                        display: block;
                                    "
                                >
                                    <option :value="1">Ativos</option>
                                    <option :value="0">Inativos</option>
                                    <option :value="-1">Todos</option>
                                </select>
                            </th>
                            <th class="table-primary">
                                <label
                                    role="button"
                                    @click="
                                        orderBy('subscription.end_subscription')
                                    "
                                    >Subsri&ccedil;&atilde;o</label
                                >
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in displayed" :key="data.id">
                            <td>{{ data.id }}</td>
                            <td>
                                <div class="icheck-primary">
                                    <input
                                        type="checkbox"
                                        :name="`check${data.id}`"
                                        :id="`check${data.id}`"
                                        :checked="selected.includes(data.email)"
                                        @change="select(data.email)"
                                    />
                                    <label :for="`check${data.id}`"></label>
                                </div>
                            </td>
                            <td>{{ data.email }}</td>
                            <td>{{ data.name }}</td>
                            <td>{{ data.level }}</td>
                            <td>{{ data.phone }}</td>
                            <td>
                                <label
                                    v-if="data.subscription_active"
                                    class="text-success"
                                >
                                    {{ t("profile.active") }}
                                </label>
                                <label v-else class="text-danger">
                                    {{ t("profile.inactive") }}
                                </label>
                            </td>
                            <td>
                                {{
                                    data.subscription
                                        ? data.subscription.end_subscription
                                        : "----"
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-12">
                    <VPagination
                        v-model="showPage"
                        :length="Math.ceil(orderUsers.length / showMaxLength)"
                    ></VPagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Fuse from "fuse.js";
import { t } from "@/lang";
import {
    ClassicEditor,
    Bold,
    Essentials,
    FontSize,
    FontSizeEditing,
    Italic,
    Mention,
    Paragraph,
    Undo,
    FontColorEditing,
    Alignment,
    Subscript,
    Superscript,
    FontColor,
    FontBackgroundColor,
    Image,
    ImageToolbar,
    ImageInsert,
    ImageCaption,
    ImageStyle,
    Link,
    ImageResizeEditing,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";

export default {
    name: "MailView",
    components: {},
    data() {
        return {
            users: [],
            user: null,
            access_key: null,
            selected: [],
            password: null,
            orders: {
                status: -1,
                by: null,
                asc: true,
                dates: [],
            },
            q: "",
            showMaxLength: 10,
            showPage: 1,
            email: {
                subject: "assunto do email",
                message: "Mensagem",
                attach: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                plugins: [
                    Essentials,
                    Bold,
                    Paragraph,
                    Italic,
                    Mention,
                    Undo,
                    FontColorEditing,
                    Alignment,
                    Subscript,
                    Superscript,
                    FontColor,
                    FontBackgroundColor,
                    FontSize,
                    FontSizeEditing,
                    Link,

                    Image,
                    ImageToolbar,
                    ImageCaption,
                    ImageStyle,
                    ImageInsert,
                    ImageResizeEditing,
                ],

                fontSize: {
                    options: [16, 12, 14, 18, 20, 22, 24],
                },
                toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "fontSize",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "fontColor",
                    "fontBackgroundColor",
                    "|",
                    "alignment",
                    "|",
                    "subscript",
                    "superscript",
                    "|",
                    "link",
                    "insertImage",
                ],
                image: {
                    toolbar: [
                        "imageTextAlternative",
                        "imageStyle:inline",
                        "imageStyle:block",
                        "imageStyle:side",
                    ],
                },
            },
        };
    },
    async created() {
        document.title = "Enviar Email";
        this.SET_LOADING(true);
        await Promise.all([this.getUser(), this.getUsers()]);
        this.SET_LOADING(false);
    },

    computed: {
        ...mapState(["loading"]),
        searchedUsers() {
            let data = this.users;
            if (this.q && this.q.length > 0) {
                // aplicar filtro de busca em name, id, email, phone
                const options = {
                    keys: [
                        "name",
                        "id",
                        "email",
                        "phone",
                        "subscription.end_subscription",
                    ],
                    ignoreDiacritics: true,
                };
                const fuse = new Fuse(data, options);
                data = fuse.search(this.q).map(({ item }) => item);
            }
            // aplicar filtro de data (depois de filtro de pesquisa)
            if (this.orders.dates && this.orders.dates.length > 0) {
                const date1 = this.orders.dates[0];
                const date2 = this.orders.dates[this.orders.dates.length - 1];
                data = data.filter((val) => {
                    if (!val.subscription) {
                        return false;
                    }
                    const date = new Date(val.subscription.end_subscription);
                    return date >= new Date(date1) && date <= new Date(date2);
                });
            }
            return data;
        },
        orderUsers() {
            let data = this.searchedUsers;
            if (this.orders.status > -1) {
                data = data.filter(({ subscription_active }) =>
                    this.orders.status == 1
                        ? subscription_active
                        : !subscription_active,
                );
            }

            if (this.orders.by) {
                data.sort((a, b) => {
                    let valA = a[this.orders.by];
                    let valB = b[this.orders.by];
                    if (this.orders.by.includes(".")) {
                        valA = a.subscription
                            ? a.subscription.end_subscription
                            : "----";
                        valB = b.subscription
                            ? b.subscription.end_subscription
                            : "----";
                    }

                    // Normaliza datas
                    if (valA instanceof Date && valB instanceof Date) {
                        valA = valA.getTime();
                        valB = valB.getTime();
                    }

                    // Comparação strings (locale-aware)
                    if (typeof valA === "string" && typeof valB === "string") {
                        return this.orders.asc
                            ? valA.localeCompare(valB, "pt-BR")
                            : valB.localeCompare(valA, "pt-BR");
                    }

                    // Comparação números e datas
                    if (valA === valB) return 0;
                    return this.orders.asc
                        ? valA > valB
                            ? 1
                            : -1
                        : valA < valB
                          ? 1
                          : -1;
                });
            }
            return data;
        },
        displayed() {
            return []
                .concat(this.orderUsers)
                .slice(
                    (this.showPage - 1) * this.showMaxLength,
                    (this.showPage - 1) * this.showMaxLength +
                        this.showMaxLength,
                );
        },
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_USER", "SET_LOADING"]),
        async sendMail() {
            this.SET_LOADING(true);
            const formData = new FormData();
            formData.append("subject", this.email.subject);
            formData.append("message", this.email.message);
            this.selected.forEach((email) => {
                formData.append("emails[]", email);
            });
            if (this.email.attach) {
                formData.append("attach", this.email.attach);
            }
            const res = await this.post({
                url: "admin/sendmail",
                data: formData,
                formData: formData,
            });
            if (res.status == 200) {
                alert("Email enviado com sucesso");
            } else {
                console.log(res.data);
                alert(res.data.message);
            }
            this.SET_LOADING(false);
        },
        selectAll({ target: { checked } }) {
            if (checked) {
                this.orderUsers.forEach(({ email }) => {
                    if (!this.selected.includes(email)) {
                        this.selected.push(email);
                    }
                });
            } else {
                this.selected = [];
            }
        },
        select(email) {
            if (this.selected.includes(email)) {
                this.selected.splice(this.selected.indexOf(email), 1);
            } else {
                this.selected.push(email);
            }
        },
        orderBy(key) {
            if (this.orders.by == key) {
                // inverter ordem
                this.orders.asc = !this.orders.asc;
            }
            this.orders.by = key;
        },
        async getUsers() {
            const response = await this.get({ url: "admin/users" });
            this.users = response.data.users;

            if (response.status != 200) {
                alert(response.data.message);
                location = "/profile";
            }
        },
        changeAttach(evt) {
            this.email.attach = evt.target.files[0];
        },
        async getUser() {
            const response = await this.get({ url: "user" });
            if (response.status == 200) {
                this.user = response.data.user;
            } else {
                alert(response.data.message);
            }
        },
        t,
    },
};
</script>

<style lang="scss" scoped>
// @import 'dastatables.net-bs5';
.upload-btn {
    bottom: 0px;
    right: 0px;
}
</style>
